import { Component, OnInit, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../../security/authentication/authentication.service';
import { PrincipalService } from '../../security/authentication/principal.service';
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
// import { PasswordChangeDialogComponent } from '../../user/password-change-dialog/password-change-dialog.component';
import { environment } from 'src/environments/environment';
import { NavbarService } from './services/navbar.service';
import { RefreshLoginDialogComponent } from './refresh-login-dialog/refresh-login-dialog.component';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { LoginService } from 'src/app/shared/login/login.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  environment: any;
  username: string;
  loading: boolean;
  manual: string;
  refreshLogin;
  refreshLoginSubscription: Subscription;
  navigateSubscription: Subscription;
  downloadManualSubscription: Subscription;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authenticationService: AuthenticationService,
    private principalService: PrincipalService,
    private navbarService: NavbarService,
    private router: Router,
    public dialog: MatDialog,
    private utils: UtilsService,
    private loginService: LoginService
  ) {
    this.navigateSubscription = router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
    this.loading = true;
    if (environment.manual && environment.manual !== '') {
      this.manual = environment.manual;
    }
  }

  ngOnInit() {
    const user = this.principalService.getUser();
    this.username = this.principalService.getUser()
      ? this.principalService.getUser().username
      : 'Camarón';
    clearTimeout(this.refreshLogin);
    this.refreshLogin = setTimeout(this.onFormClosePeriod, user.timeout * 0.9, user.timeout, this);
  }

  downloadManual() {
    this.downloadManualSubscription = this.navbarService.getManual().subscribe(
      data => this.utils.saveFile(data.body, this.manual),
      error => console.log('Error downloading the file.')
    );
  }

  // changePassword() {
  //   const dialogRef = this.dialog.open(PasswordChangeDialogComponent, {
  //     width: '350px'
  //   });

  //   dialogRef.afterClosed().subscribe(result => {});
  // }

  logout() {
    //console.log('navbar.component - logout');
    if (this.loginService.loggedFromSSO) {
      this.loginService.logoutSSO();
    } else {
      this.cancelRefreshLogin();
      this.authenticationService.logout(this.principalService.getUser().username)
      .subscribe(() => this.router.navigate(['/login']));
  
    }
  }

  /* Esconde o muestra la progress bar durante cambios de RouterEvent */
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
      if (event.url !== '/login') {
        //console.log('navbar.component - navigationInterceptor - no /login');
        this.refreshLoginSubscription = this.authenticationService.refreshLogin().subscribe(
          data => {},
          error => {
            //console.log('navbar.component - navigationInterceptor - error - forceLogout');
            this.forceLogout(this, null, false);
          }
        );
        clearTimeout(this.refreshLogin);
        const user = this.principalService.getUser();
        //console.log('navbar.component - navigationInterceptor - user: ', user);
        this.refreshLogin = setTimeout(
          this.onFormClosePeriod,
          user.timeout * 0.9,
          user.timeout,
          this
        );
      }
    }
    if (event instanceof NavigationEnd) {
      this.loading = false;
    }

    /* Oculta la barra en caso de que la petición falle */
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }

  onFormClosePeriod(time: number, _this) {
    const dialogRef = _this.dialog.open(RefreshLoginDialogComponent, {});
    const doLogout = setTimeout(_this.forceLogout, time * 0.1, _this, dialogRef, true);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        _this.authenticationService.refreshLogin().subscribe(
          data => {},
          error => {
            _this.forceLogout(_this, dialogRef, false);
          }
        );
        clearTimeout(doLogout);
        _this.refreshLogin = setTimeout(_this.onFormClosePeriod, time * 0.9, time, _this);
      } else {
        _this.forceLogout(_this, dialogRef, false);
      }
    });
  }

  forceLogout(_this, dialogRef, open) {
    //console.log('navbar.component - forceLogout');
    if (open) {
      dialogRef.close();
    }
    _this.logout();
  }

  cancelRefreshLogin() {
    clearTimeout(this.refreshLogin);
  }

  ngOnDestroy() {
    if (this.refreshLoginSubscription) {
      this.refreshLoginSubscription.unsubscribe();
    }
    if (this.navigateSubscription) {
      this.navigateSubscription.unsubscribe();
    }
    if (this.downloadManualSubscription) {
      this.downloadManualSubscription.unsubscribe();
    }
    clearTimeout(this.refreshLogin);
  }
}
